module.exports = __webpack_public_path__ + "static/jsh-logo-5cb964a2657639e98207aa9e4f7c4ab8.jpg";